import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { LANGUAGES, useT } from '../context/LanguageContext';
import { Flag } from './Flags';

export const LanguageSwitcher = () => {
  const { lang, languages, setLang, translationNotice } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang) || languages[0] || LANGUAGES[0];

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="language-select"
        aria-label={`Språk: ${current.label}`}
        aria-expanded={open}
        className="h-10 px-2.5 md:px-3 rounded-full bg-white/5 border border-white/15 text-white text-xs font-bold flex items-center gap-1.5 hover:border-[#ff2e2e] focus:outline-none focus:border-[#ff2e2e] transition-colors"
      >
        <Flag code={current.flag} />
        <span className="hidden md:inline">{current.short}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div data-testid="language-menu" className="absolute right-0 mt-2 w-40 max-h-[min(70dvh,28rem)] overflow-y-auto rounded-2xl bg-[#0f0a17] border border-white/10 shadow-2xl p-1.5 z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`language-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors ${l.code === lang ? 'bg-[#ff2e2e]/15 text-white' : 'text-white/70 hover:bg-white/5 hover:text-white'}`}
            >
              <Flag code={l.flag} />
              <span className="flex-1 text-left">{l.label}</span>
              {l.code === lang && <Check size={14} className="text-[#ff2e2e]" />}
            </button>
          ))}
          {translationNotice && <p role="status" className="px-3 py-2 text-[11px] leading-relaxed text-amber-300">{translationNotice}</p>}
        </div>
      )}
    </div>
  );
};
